import React from "react";
import { RaterStatusCellProps } from "../raterStatusCell";
import ScoringStatusCell, { ScoringStatusCellProps } from "../scoreStatusCell";
import { SelfStatusCellProps } from "../selfStatusCell";
import BaseLegendTable from "./baseLegendTable";

interface ScorableLegendTableProps {}

const ScorableLegendTable: React.FC<ScorableLegendTableProps> = () => {
    const data: {
        cellData: ScoringStatusCellProps;
        comment: string;
    }[] = [
        {
            cellData: { status: 5 },
            comment: "Assessment has been deactivated or cancelled",
        },
        {
            cellData: { status: 0 },
            comment: "Minimum requirements for scoring have not been met",
        },
        {
            cellData: { status: 1 },
            comment: "Assessment is scorable",
        },
        {
            cellData: { status: 2 },
            comment: "Assessment has been scored",
        },
    ];

    return (
        <BaseLegendTable
            statusCellType={
                ScoringStatusCell as React.ElementType<
                    SelfStatusCellProps | RaterStatusCellProps | ScoringStatusCellProps
                >
            }
            data={data}
            title="360 Scorability"
        />
    );
};

export default ScorableLegendTable;
